export const certmngConstants = {

  /*********
   증명서 신청 검색조건 변경
   **********/
  SELECT_SEARCH_REQUEST: 'SELECT_SEARCH_REQUEST',

  /*********
   증명서 신청 목록 조회
   **********/
  CERTMNG_REQUEST: 'GET_CERTMNG_REQUEST',
  CERTMNG_SUCCESS: 'GET_CERTMNG_SUCCESS',
  CERTMNG_FAILURE: 'GET_CERTMNG_FAILURE',

  /*********
   증명서 신청 상세 조회
   **********/
  DETAIL_REQUEST: 'GET_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'GET_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'GET_DETAIL_FAILURE',

  /*********
   증명서 신청 상세선택
   **********/
  SELECT_REQUEST: 'SELECT_CERTMNG_REQUEST',

  /***********
   증명서 신청 히스토리 관리
   ************/
  CERTMNG_HISTORY: 'SET_CERTMNG_HISTORY',

}
